import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";

import React from "react";
import ConfirmPopUpMobilization from "../../MobilizationData/ConfirmPopUp/ConfirmPopUpMobilization";
import nodeinstance from "../../../../../nodeInstance";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import TwoPopuP from "./FinalExitQuePopUpTwo";

export default function FinalExitQueuePopup({
  PopUp,
  setPopUp,
  callBack,
  url,
  propData,
}) {
  console.log("last page data to be seen in consle", propData);
  // const [yesPopup, setYesPopup] = useState(false);
  const [issueDate, setIssueDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [finalDate, setFinalDate] = useState("");

  const IssueChange = (e) => {
    setIssueDate(e.target.value);
  };
  const ExpiryChange = (e) => {
    setExpiryDate(e.target.value);
  };
  const finalDateChange = (e) => {
    setFinalDate(e.target.value);
  };
  const token = localStorage.getItem("nodeToken");
  // const token = localStorage.getItem("nodeToken");
  const navigate = useNavigate();
  const [TwoPopUp, setTwoPopUp] = useState(false);
  const UpdatePopUpTwo = () => {
     setTwoPopUp(true)
  }
  const updateData = async () => {
    try {
      // alert("............................................")
      const reqObj = {
        employee_id: propData.candidate_id,
        demobilization_type: propData.demobilization_type,
      };
      const response = await nodeinstance.put(
        `/mobilization/cancelAPIExit`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        callBack();
        setPopUp(false);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  const dispatch = useDispatch();

  const onSubmit = async () => {
    if (
      propData.Issue_date_status === "DONE" &&
      propData.Final_exit_status != "AUTHORISE"
    ) {
      dispatch(
        setAppError({
          msg: "Exit formalities should be done to proceed further..",
          // color: "success",
        })
      );
      return;
    }
    try {
      let reqObj;
      if (propData.Issue_date_status === "DONE") {
        reqObj = {
          employeeTable: true,
          Exit_country_or_nakal_kafala_date: finalDate,
          employee_id: propData.candidate_id,
        };
      } else {
        reqObj = {
          Final_exit_issue_date: issueDate,
          Final_exit_expiry_date: expiryDate,
          employee_id: propData.candidate_id,
          Issue_date_status: "DONE",
          employeeTable: false,
        };
      }

      const response = await nodeinstance.put(
        `/mobilization/issuefinalexitdate`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        callBack();
        setPopUp(false);
      }
    } catch (error) {
      console.log("error to be printed in console", error);
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {propData.Issue_date_status === "DONE" ? (
            <>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">
                    {propData.demobilization_type === "NAKAL KAFALA-FINAL EXIT"
                      ? "NAKAL KAFALA- EXIT DATE"
                      : "EXIT FROM THE COUNTRY DATE"}
                  </span>
                </label>
                <input
                  type="date"
                  className="input input-sm input-bordered"
                  required
                  min={propData?.demobilization_date?.split("T")[0]}
                  onChange={finalDateChange}
                />
              </div>
            </>
          ) : (
            <>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">FINAL EXIT ISSUE DATE</span>
                </label>
                <input
                  type="date"
                  className="input input-sm input-bordered"
                  required
                  // min={propData?.demobilization_date?.split("T")[0]}
                  onChange={IssueChange}
                />
              </div>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">FINAL EXIT EXPIRY DATE</span>
                </label>

                <input
                  type="date"
                  className="input input-sm input-bordered"
                  required
                  // min={issueDate}
                  onChange={ExpiryChange}
                />
              </div>
            </>
          )}

          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="p-3 bg-blue text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => {
                    UpdatePopUpTwo();
                  }}
                >
                  Cancel Final Exit
                </button>
                <button
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => onSubmit()}
                >
                  <p>Submit</p>
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {TwoPopUp ? (
        <TwoPopuP TwoPopUp ={TwoPopUp} setTwoPopUp={setTwoPopUp} demobilization_type =  {propData.demobilization_type} updateData={updateData}  />
      ) : (
        ""
      )}
    </>
  );
}
